import { render, staticRenderFns } from "./LocalUpload.vue?vue&type=template&id=5abb335b&scoped=true"
import script from "./LocalUpload.vue?vue&type=script&lang=js"
export * from "./LocalUpload.vue?vue&type=script&lang=js"
import style0 from "./LocalUpload.vue?vue&type=style&index=0&id=5abb335b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb335b",
  null
  
)

export default component.exports